<template>
  <div id="footer">
    <div class="container clearfix">
      <div class="about col-12 col-4-t">
        <h1 class="aboutTitle">關於 六角西餐廳</h1>
        <p class="des">Curabitur lobortis id lorem id bibndum. Ut id consectetur magna. Quisque volutpat augue enim, pulvinar lobortis nibh lacinia at. 
        </p>
      </div>
      <div class="contact col-12 col-4-t">
        <h3 class="contactTitle">聯絡方式</h3>
        <ul class="infoList">
          <li>高雄市中正五路到底</li>
          <li>+886 886 886</li>
          <li>service@hexschool.com</li>
        </ul>
      </div>
      <div class="footerLogo clearfix">
        <img src="../assets/logo_l@svg.svg" alt="logo">
        <ul id="socialMedia" class="clearfix">
          <li><i class="icon-googleplus"></i></li>
          <li><i class="icon-twitter"></i></li>
          <li><i class="icon-facebook"></i></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'infoFooter'
  }
</script>

<style lang="scss" scoped>
  #footer {
    padding: 50px 0;
    background-color: #EFE9E7;
    .container {
      width: 90%;
    }
    .about, .contact {
      margin-bottom: 30px;
    }
    .aboutTitle, .contactTitle {
      color: #3D1101;
      font-size: 24px;
      font-weight: normal;
    }
    .des {
      margin-top: 1rem;
    }
    .infoList {
      margin-top: 1rem;
      padding-left: 20px;
      color: #3D1101;
    }
    .footerLogo {
      float: right;
      margin-top: 30px;
    }
    #socialMedia {
      list-style: none;
      ul {
        float: right;
      }
      li {
        float: right;
        margin-top: 22px;
        margin-left: 12px;
        font-size: 24px;
      }
      .icon-googleplus {
        color: #dd4b39;
      }
      .icon-twitter {
        color: #1da1f2;
      }
      .icon-facebook {
        color: #3b5998;
      }
    }
  }

  @media (min-width: 768px) {
    #footer {
      .container {
        width: 98%;
      }
      .about {
        margin-right: 1rem;
      }
    }
  }
  @media (min-width: 992px) {
    #footer {
      .container {
        width: 90%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/infoFooter.vue